<template>
  <div class="fans">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <van-row type="flex" justify="space-between" v-for="(item,index) in list" :key="'list_' + item.id">
      <van-col span="4">
        <img class="listhand" :src="item.headimg_url&&item.headimg_url.substring(0,5)=='https'?item.headimg_url:img.avatar">
      </van-col>
      <van-col span="19" offset="1" v-if="item.intro==''">
        <div class="activename">
          {{item.user_name}}
        </div>
      </van-col>
      <van-col span="19" offset="1" v-else>
        <div class="membername">{{item.user_name}}</div>
        <div class="sourtime">
         {{item.intro}}
       </div>
     </van-col>

     <van-col class="bintright" span="4">
       <van-button class="inter" v-if="item.is_inter">互相关注</van-button>
       <van-button  v-else icon="plus" color="#5F5B6B" size="small"  @click="follow(index)" :data-code="item.id">关注</van-button>
     </van-col>
   </van-row>
 </van-list>
    <!-- <van-row type="flex" justify="space-between">
      <van-col span="4">
        <img class="listhand" :src="img.avatar">
      </van-col>
      <van-col span="19" offset="1">
        <div class="membername">哪吒Nz</div>
        <div class="sourtime">
         这个家伙很懒，什么都没有留下~
       </div>
     </van-col>
     <van-col class="bintright" span="4">
      <van-button class="inter">互相关注</van-button>
    </van-col>
  </van-row>
  <van-row type="flex" justify="space-between">
    <van-col span="4">
      <img class="listhand" :src="img.avatar">
    </van-col>
    <van-col span="19" offset="1">
      <div class="membername">哪吒Nz</div>
      <div class="sourtime">
       这个家伙很懒，什么都没有留下~
     </div>
   </van-col>
   <van-col class="bintright" span="4">
    <van-button color="#5F5B6B">+ 关注</van-button>
  </van-col>
</van-row> -->
</div>
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/memberinfo';
  import follow from '../../../api/content';
  import { mapState } from 'vuex';
  import { Row, Col, Button,List } from "vant";
  export default {
    data () {
      return {
        loading: false,
        finished: false,
        list:[],
        params:{
          page:1,
          size:10
        },
        img:{
         loading: require('../../../assets/img/loading_lexus.gif'),
         avatar: require('../../../assets/img/lexus/default.png'),
       }
     }
   },
   computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    var params={
      event_code: '关注列表',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/MyFans.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    follow(index){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      let type = this.list[index].is_inter ? 2 : 1;
      follow.Follow({follow_user_id: this.list[index].id, type: type}).then(res => {
        if(res.data.state == 1) {
          if(type == 1) {
            this.list[index].is_inter=true
          } else {
            this.list[index].is_inter=false
          }
        }
      })
    },
    onLoad(){
      setTimeout(() => {
        list.getMyFans(this.params).then(res => {
          this.list.push.apply(this.list, res.data.data.data)
          this.params.page += 1
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
    },
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [List.name]:List
  }
}
</script>

<style lang="scss">
.fans{
  padding: 15px;
  .bintright{
    text-align:right;
    .inter{
      background-color: #F3F9FF;
      color: #728FC4;
    }
  }
  .van-button{
    min-width: 1.6rem;
    height: 28px;
    font-size: 12px;
    line-height: 2;
    padding: 0;
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
  }
  .listhand{
    width:45px;
    height:45px;
  }
  .membername{
    font-size: 15px;
    font-weight: bold;
  }
  .van-row{
    margin-top: 20px;
  }
}
</style>
